import { observer } from 'mobx-react';

import selectedListStyles from '@components/SelectList/SelectList.module.scss';

import { OrganizationSelectItem } from '@core/Page/LeftMenu/UserProfile/OrganizationSelect/OrganizationSelectItem';
import { authUserService } from '@store/AuthUser/services/authUserService';
import { store } from '@store';

interface Props {
    onSelect(organizationId?: string): void;
}

export const OrganizationSelect = observer(({ onSelect }: Props) => {
    const {
        authUser: { organizationId },
    } = store;

    const organizationOptions = authUserService.makeOrganizationOptions();

    return (
        <div className={selectedListStyles.root}>
            {organizationOptions.map(organization => (
                <OrganizationSelectItem
                    key={organization.value}
                    selectedId={organizationId}
                    onSelect={onSelect}
                    organization={organization}
                />
            ))}
        </div>
    );
});
